//src/contexts/CartContext

import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  // 🔁 Persistência simples (localStorage)
  useEffect(() => {
    const stored = localStorage.getItem("cart_items");
    if (stored) {
      setItems(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("cart_items", JSON.stringify(items));
  }, [items]);

  function addToCart(course) {
    setItems((prev) => {
      if (prev.find((c) => c.id === course.id)) return prev;
      return [...prev, course];
    });
  }

  function removeFromCart(courseId) {
    setItems((prev) => prev.filter((c) => c.id !== courseId));
  }

  function clearCart() {
    setItems([]);
  }

  const total = items.reduce(
    (sum, c) => sum + Number(c.price || 0),
    0
  );

  return (
    <CartContext.Provider
      value={{
        items,
        addToCart,
        removeFromCart,
        clearCart,
        total,
        count: items.length,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart deve ser usado dentro de <CartProvider>");
  }
  return context;
}
